const countries = [
	{
		country: "United Kingdom",
		hreflang: "en-GB",
		href: "https://www.fanhome.com/uk",
		code: "uk",
	},
	{
		country: "Deutschland",
		hreflang: "de-DE",
		href: "https://www.fanhome.com/de",
		code: "de",
	},
	{
		country: "United States",
		hreflang: "en-US",
		href: "https://www.fanhome.com/us",
		code: "us",
	},
	{
		country: "Austria",
		hreflang: "de-AT",
		href: "https://www.fanhome.com/at",
		code: "at",
	},
	{
		country: "Netherlands",
		hreflang: "nl-NL",
		href: "https://www.fanhome.com/nl",
		code: "nl",
	},
	{
		country: "Canada",
		hreflang: "en-CA",
		href: "https://www.fanhome.com/ca",
		code: "ca",
	},
];

export default countries;
